export const API_ERRORS = 'API_ERRORS';
export const LOAD_STATE = 'LOAD_STATE';
export const SET_INITIAL_MEMBERSHIP_ROLE = 'SET_INITIAL_MEMBERSHIP_ROLE';
export const SET_SELECTED_TEAMS = 'SET_SELECTED_TEAMS';
export const SET_SELECTED_PROJECTS = 'SET_SELECTED_PROJECTS';
export const SET_WEEKLY_ALLOWED_HOURS = 'SET_WEEKLY_ALLOWED_HOURS';
export const SET_EXPECTED_HOURS = 'SET_EXPECTED_ALLOWED_HOURS';
export const SET_DAILY_ALLOWED_HOURS = 'SET_DAILY_ALLOWED_HOURS';
export const UPDATE_FIELD = 'UPDATE_FIELD';
export const UPDATE_ALLOW_RECEIVING_EMAILS = 'UPDATE_ALLOW_RECEIVING_EMAILS';
export const UPDATE_TEAMS = 'UPDATE_TEAMS';
export const UPDATE_ROLE = 'UPDATE_ROLE';
export const UPDATE_PROJECTS = 'UPDATE_PROJECTS';
export const UPDATE_MEMBERSHIP_PROJECTS = 'UPDATE_MEMBERSHIP_PROJECTS';
export const UPDATE_LINKED_PROJECTS = 'UPDATE_LINKED_PROJECTS';
export const UPDATE_MULTIPLE_PROJECTS = 'UPDATE_MULTIPLE_PROJECTS';
export const UPDATE_MULTIPLE_TEAMS = 'UPDATE_MULTIPLE_TEAMS';
export const ADD_TEAM_TO_PROJECTS = 'ADD_TEAM_TO_PROJECTS';
export const UPDATE_LEADED_TEAMS = 'UPDATE_LEADED_TEAMS';
export const ADD_TEAM_VIA_PROJECTS = 'ADD_TEAM_VIA_PROJECTS';
export const REMOVE_TEAM_FROM_PROJECTS = 'REMOVE_TEAM_FROM_PROJECTS';
export const REMOVE_RECURRING_DAILY_LIMIT = 'REMOVE_RECURRING_DAILY_LIMIT';
export const REMOVE_RECURRING_WEEKLY_LIMIT = 'REMOVE_RECURRING_WEEKLY_LIMIT';
export const REMOVE_EXPECTED_PER_WEEK = 'REMOVE_EXPECTED_PER_WEEK';
export const UPDATE_CURRENT_WEEKLY_LIMIT = 'UPDATE_CURRENT_WEEKLY_LIMIT';
export const UPDATE_CURRENT_EXPECTED_PER_WEEK = 'UPDATE_CURRENT_EXPECTED_PER_WEEK';
export const UPDATE_CURRENT_DAILY_LIMIT = 'UPDATE_CURRENT_DAILY_LIMIT';
export const UPDATE_DOW_LIMIT = 'UPDATE_DOW_LIMIT';
export const UPDATE_DOW_EXPECTED = 'UPDATE_DOW_EXPECTED';
export const SET_PAYMENT_PERIOD_START = 'SET_PAYMENT_PERIOD_START';
export const UPDATE_MEMBERSHIP = 'UPDATE_MEMBERSHIP';
export const SET_SUBMITTING = 'SET_SUBMITTING';
export const SET_ERRORS = 'SET_ERRORS';
export const RESET_FIELDS = 'RESET_FIELDS';
export const SET_PAY_TYPES = 'SET_PAY_TYPES';
export const SET_TABLE_LOADING = 'SET_TABLE_LOADING';
export const SET_DIALOG_LOADING = 'SET_DIALOG_LOADING';
export const SET_STATIC_URLS = 'SET_STATIC_URLS';
export const SET_BATCH_ACTION_IDS = 'SET_BATCH_ACTION_IDS';
export const SET_FILTER = 'SET_FILTER';
export const UPDATE_TABLE_COLUMNS = 'UPDATE_TABLE_COLUMNS';
export const UPDATE_PAYMENT_SECTION = 'UPDATE_PAYMENT_SECTION';
export const SET_MEMBER_RATES = 'SET_MEMBER_RATES';
export const SET_MEMBERS_RATES_LOADING = 'SET_MEMBERS_RATES_LOADING';
export const UPDATE_CUSTOM_FIELDS = 'UPDATE_CUSTOM_FIELDS';
export const UPDATE_ABOUT_FIELDS = 'UPDATE_ABOUT_FIELDS';
export const SET_FILE_PARAMS = 'SET_FILE_PARAMS';
export const REMOVE_FILE = 'REMOVE_FILE';
export const SET_UPLOAD_LOADING = 'SET_UPLOAD_LOADING';
export const SET_MEMBERS_UPDATE_PROFILE_FIELDS_SETTINGS_LOADING = 'SET_MEMBERS_UPDATE_PROFILE_FIELDS_SETTINGS_LOADING';
export const SET_MEMBERS_UPDATE_PROFILE_FIELDS_SETTINGS = 'SET_MEMBERS_UPDATE_PROFILE_FIELDS_SETTINGS';
export const SET_MEMBERS_UPDATE_PROFILE_FIELDS_FILES_LOADING = 'SET_MEMBERS_UPDATE_PROFILE_FIELDS_FILES_LOADING';
export const RESET_CHANGES = 'RESET_CHANGES';
export const RESET_PROJECTS = 'RESET_PROJECTS';
export const UPDATE_EMAIL = 'UPDATE_EMAIL';
